import './index.scss';
import React, { useState, useEffect } from 'react';
import { List, InputItem, TextareaItem, Button } from 'antd-mobile';
import { list } from '@/services/saas/supervisionSet';

/** 课堂行为组件 */
function ClassroomBehavior(props) {
  const { value = {}, disabled = false, handleChange, refresh, onRefresh } = props;

  const [tremet, setTremet] = useState([]);
  const [stuact, setStuact] = useState([]);
  const [claano, setClaano] = useState([]);

  const getActivity = async () => {
    const resp = await list();
    if (resp && resp.success) {
      const temp = {};
      resp.data.forEach((item) => {
        if (temp[item.type] === undefined) {
          temp[item.type] = [];
        }
        temp[item.type].push(item);
      });
      Object.keys(temp).forEach((type) => {
        const value = temp[type];
        if (type === '1') {
          setTremet(value);
        }
        if (type === '2') {
          setStuact(value);
        }
        if (type === '4') {
          setClaano(value);
        }
      });
    }
  };

  const setActivity = (key, item) => {
    if (disabled) {
      return;
    }
    if (!value[key]) {
      value[key] = '';
    }
    let items = value[key].split(',').filter((v) => !!v);
    const index = items.findIndex((v) => v === item.name);
    if (index > -1) {
      items = items.filter((v) => v !== item.name);
    } else {
      items.push(item.name);
    }
    value[key] = items.join(',');
    handleChange(value);
  };

  const getStatus = (value, key) => {
    return value ? value.split(',').findIndex((v) => v === key) > -1 : false;
  };

  useEffect(() => {
    getActivity();
  }, []);

  return (
    <div className="classroom-behavior">
      <div className="classroom-behavior-content">
        {((!disabled && tremet.length > 0) || (disabled && value.teacherActivitier)) && (
          <div className="classroom-behavior-term">
            <h3>处理方式</h3>
            <ul className="classroom-behavior-list">
              {!disabled && (
                <>
                  {tremet.map((item, index) => {
                    return (
                      <li
                        key={'tremet_' + item.id}
                        className={
                          getStatus(value.teacherActivitier, item.name)
                            ? 'classroom-behavior-list-item active'
                            : 'classroom-behavior-list-item'
                        }
                        onClick={() => setActivity('teacherActivitier', tremet[index])}
                      >
                        {item.name}
                      </li>
                    );
                  })}
                </>
              )}
              {disabled &&
                value.teacherActivitier &&
                value.teacherActivitier.split(',').map((name, index) => (
                  <li key={'tremet_' + index} className="classroom-behavior-list-item ">
                    {name}
                  </li>
                ))}
            </ul>
          </div>
        )}
        {((!disabled && stuact.length > 0) || (disabled && value.studentActivitier)) && (
          <div className="classroom-behavior-term">
            <h3>学生活动</h3>
            <ul className="classroom-behavior-list">
              {!disabled &&
                stuact.map((item, index) => {
                  return (
                    <li
                      key={'stuact_' + item.id}
                      className={
                        getStatus(value.studentActivitier, item.name)
                          ? 'classroom-behavior-list-item active'
                          : 'classroom-behavior-list-item'
                      }
                      onClick={() => setActivity('studentActivitier', stuact[index])}
                    >
                      {item.name}
                    </li>
                  );
                })}
              {disabled &&
                value.studentActivitier &&
                value.studentActivitier.split(',').map((name, index) => (
                  <li key={'stuact_' + index} className="classroom-behavior-list-item ">
                    {name}
                  </li>
                ))}
            </ul>
          </div>
        )}
        <div className="classroom-behavior-term disciplinary-offence">
          <h3>违纪行为</h3>
          {refresh && (
            <div onClick={onRefresh} className="refresh">
              <svg
                viewBox="64 64 896 896"
                focusable="false"
                className=""
                data-icon="reload"
                width="1em"
                height="1em"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"></path>
              </svg>
            </div>
          )}
          <div className="disciplinary-offence-main">
            <List className="">
              <InputItem
                disabled={disabled}
                maxLength={4}
                value={value.sleepNum}
                type={'number'}
                placeholder=""
                moneyKeyboardAlign="right"
                disabledKeys={['.']}
                onChange={(sleepNum) => {
                  handleChange({ ...value, sleepNum: sleepNum * 1 });
                }}
              >
                睡觉人数
              </InputItem>
            </List>
            <List>
              <InputItem
                disabled={disabled}
                maxLength={4}
                value={value.absenceNum}
                type={'number'}
                placeholder=""
                moneyKeyboardAlign="right"
                disabledKeys={['.']}
                onChange={(absenceNum) => handleChange({ ...value, absenceNum: absenceNum * 1 })}
              >
                缺勤人数
              </InputItem>
            </List>
          </div>
          <div className="disciplinary-offence-other">
            <h4>其他</h4>
            <List>
              <TextareaItem
                disabled={disabled}
                maxLength={250}
                value={value.otherBehavior}
                rows={7}
                onChange={(otherBehavior) => {
                  handleChange({ ...value, otherBehavior });
                }}
                placeholder="输入内容..."
              />
            </List>
          </div>
        </div>
        <div className="classroom-behavior-term classroom-anomaly">
          <div className="classroom-behavior-subtitle">
            <h3>课堂异常</h3>
            <div className="classroom-anomaly-btnGroup">
              <Button
                disabled={disabled}
                className={value.ifAnormal === '1' ? 'yes active' : 'yes'}
                onClick={() => handleChange({ ...value, ifAnormal: '1' })}
              >
                是
              </Button>
              <Button
                disabled={disabled}
                className={value.ifAnormal === '2' ? 'no active' : 'no'}
                onClick={() => handleChange({ ...value, ifAnormal: '2' })}
              >
                否
              </Button>
            </div>
          </div>
          <ul className="classroom-behavior-list">
            {!disabled &&
              claano.map((item, index) => {
                return (
                  <li
                    key={'claano_' + item.id}
                    className={
                      getStatus(value.phenomenonId, item.name)
                        ? 'classroom-behavior-list-item active'
                        : 'classroom-behavior-list-item'
                    }
                    onClick={() => setActivity('phenomenonId', claano[index])}
                  >
                    {item.name}
                  </li>
                );
              })}
            {disabled &&
              value.phenomenonId &&
              value.phenomenonId.split(',').map((name, index) => (
                <li key={'stuact_' + index} className="classroom-behavior-list-item ">
                  {name}
                </li>
              ))}
          </ul>
          <h4>其他</h4>
          <List>
            <TextareaItem
              disabled={disabled}
              maxLength={60}
              value={value.otherAnormal}
              rows={7}
              onChange={(otherAnormal) => {
                handleChange({ ...value, otherAnormal });
              }}
              placeholder="输入内容..."
            />
          </List>
        </div>
      </div>
    </div>
  );
}

export default ClassroomBehavior;
